import React from "react";
import { Phone } from "@phosphor-icons/react";
import { useSite } from "../../lib/site";

export default function CallFab() {
  const site = useSite();
  const phone = site?.phone;

  if (!phone) return null;

  return (
    <a
      href={`tel:${phone}`}
      data-testid="call-fab"
      aria-label={`Call ${phone}`}
      className="fixed bottom-5 right-5 z-[60] inline-flex items-center gap-2 bg-atc-red text-white px-5 py-3 font-heading uppercase tracking-widest text-xs font-bold border-2 border-atc-red shadow-[4px_4px_0_0_#1A1A1A] hover:shadow-[6px_6px_0_0_#1A1A1A] hover:-translate-x-0.5 hover:-translate-y-0.5 transition-all"
    >
      <Phone size={18} weight="bold" />
      <span className="hidden sm:inline">Call {phone}</span>
      <span className="sm:hidden">Call Now</span>
    </a>
  );
}
